import { LOGOUT } from 'portal-modules/auth/redux/modules/user'
import { RECEIVE_CONTRACT_PROPERTY_ASSOCIATIONS } from 'portal-modules/contracts/redux/modules/contracts'

// action types
const RECEIVE_PROPERTIES = 'rp/properties/RECEIVE_PROPERTIES'
export const RECEIVE_PROPERTY_ASSOCIATIONS =
  'rp/properties/RECEIVE_PROPERTY_ASSOCIATIONS'

// reducer
export default function properties(state = {}, action) {
  switch (action.type) {
    case RECEIVE_PROPERTY_ASSOCIATIONS:
    case RECEIVE_CONTRACT_PROPERTY_ASSOCIATIONS:
      return action.payload.properties
    case RECEIVE_PROPERTIES:
      return action.payload
    case LOGOUT:
      return {}
    default:
      return state
  }
}

export const receivePropertyAssociations = payload => ({
  type: RECEIVE_PROPERTY_ASSOCIATIONS,
  payload,
})
